var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"white","border-radius":"20px","width":"100%","height":"100%","position":"relative","box-shadow":"0px 4px 10px rgba(0, 0, 0, 0.1)","border":"1px solid #ddd"},style:({
    minHeight: _vm.$vuetify.breakpoint.xl
      ? '400px'
      : _vm.$vuetify.breakpoint.lg
      ? '400px'
      : '350px',
  })},[_c('div',{staticStyle:{"border-bottom":"1px solid #ddd","height":"50%"},style:({
      display: _vm.$vuetify.breakpoint.lg ? 'block' : 'flex',
      opacity: _vm.isExceedsLimits ? 0.5 : 1,
    })},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"},style:({
        width: _vm.$vuetify.breakpoint.lg ? '100%' : '50%',
        borderRight: _vm.$vuetify.breakpoint.lg ? 'none' : '1px solid #ddd',
        borderBottom: _vm.$vuetify.breakpoint.lg ? '1px solid #ddd' : 'none',
        height: _vm.$vuetify.breakpoint.lg ? '45%' : '',
        flexDirection:
          _vm.$vuetify.breakpoint.lg || _vm.$vuetify.breakpoint.xs ? 'row' : 'column',
      })},[_c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center"},style:({
          height: _vm.$vuetify.breakpoint.lg ? '100%' : '50%',
          width: _vm.$vuetify.breakpoint.lg ? '50%' : '100%',
          borderRight: _vm.$vuetify.breakpoint.lg ? '1px solid #ddd' : 'none',
          marginTop:
            _vm.$vuetify.breakpoint.xl ||
            _vm.$vuetify.breakpoint.md ||
            _vm.$vuetify.breakpoint.sm
              ? '16px'
              : '0',
        })},[_c('div',{staticStyle:{"background-color":"#283058","border-radius":"100%","display":"flex","align-items":"center","justify-content":"center","height":"64px","width":"64px"}},[_c('img',{staticStyle:{"border-radius":"100%","object-fit":"contain","height":"64px","width":"64px"},attrs:{"src":_vm.logo,"alt":"Carrier Icon"}})])]),_c('div',{staticClass:"text-center",style:({
          width: _vm.$vuetify.breakpoint.lg ? '50%' : '100%',
          marginBottom:
            _vm.$vuetify.breakpoint.xl ||
            _vm.$vuetify.breakpoint.md ||
            _vm.$vuetify.breakpoint.sm
              ? '16px'
              : '0',
        })},[_c('h3',{staticStyle:{"font-size":"20px","font-weight":"500"},style:({ marginTop: _vm.$vuetify.breakpoint.lg ? '' : '8px' })},[_vm._v(" "+_vm._s(_vm.carrierName)+" ")]),_c('p',{staticStyle:{"color":"#a3a4ab","font-size":"12px","font-weight":"500","margin":"0","padding":"0"}},[_vm._v(" "+_vm._s(_vm.serviceType)+" ")])])]),_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center","overflow":"visible","position":"relative"},style:({
        height: _vm.$vuetify.breakpoint.lg ? '55%' : '',
        width: _vm.$vuetify.breakpoint.lg ? '100%' : '50%',
        alignItems: 'center',
        paddingTop: '8px',
      })},[_c('div',{staticStyle:{"width":"max-content","padding":"4px 16px","max-width":"100%","display":"flex","justify-content":"center","align-items":"center","background-color":"#fef1e4","color":"#fb8c01","border-radius":"100px","font-weight":"600","box-sizing":"border-box"},style:({
          fontSize: _vm.$vuetify.breakpoint.lg ? '16px' : '20px',
        })},[_vm._v(" "+_vm._s(_vm.totalCost)+" "+_vm._s(_vm.currency)+" ")]),(_vm.costBreakdown.length > 1)?_c('div',{staticClass:"price-breakdown-container",style:({
          display: 'flex',
          flexDirection: _vm.$vuetify.breakpoint.lg ? 'row' : 'column',
          flexWrap: _vm.$vuetify.breakpoint.lg ? 'wrap' : 'nowrap',
          gap: '4px',
          padding: '4px 8px 0 8px',
          width: '100%',
          maxHeight: '100%',
          overflow: 'visible',
          position: 'relative',
        })},[(!_vm.$vuetify.breakpoint.lg)?[_vm._l((_vm.visibleItems),function(item,index){return _c('div',{key:index,staticClass:"price-breakdown-item",style:({
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              minWidth: 0,
              maxWidth: '100%',
              marginBottom: '2px',
            })},[_c('div',{staticClass:"price-label",style:({
                color: '#a3a4ab',
                fontWeight: '500',
                fontSize: '11px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                flex: '1',
                marginRight: '8px',
              })},[_vm._v(" "+_vm._s(item.DisplayName || _vm.priceTypes[item.PriceType])+" ")]),_c('div',{staticClass:"price-value",style:({
                padding: '4px 8px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#e7f2fd',
                borderRadius: '12px',
                fontSize: '11px',
                fontWeight: '500',
                color: '#2396f3',
                minHeight: '24px',
                whiteSpace: 'nowrap',
                flexShrink: 0,
              })},[_vm._v(" "+_vm._s(item.Value.toFixed(2))+" "+_vm._s(_vm.currency)+" ")])])}),(_vm.hasHiddenItems)?_c('div',{style:({
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              position: 'relative',
            }),on:{"click":_vm.toggleShowAll}},[_c('div',{style:({
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                color: '#2396f3',
                fontSize: '12px',
                fontWeight: '500',
              })},[_c('span',[_vm._v(_vm._s(_vm.showAll ? 'Daha Az' : `+${_vm.hiddenItemsCount} Daha`))]),_c('v-icon',{style:({ 
                  fontSize: '16px',
                  transform: _vm.showAll ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.2s ease'
                })},[_vm._v(" mdi-chevron-down ")])],1)]):_vm._e()]:[_vm._l((_vm.horizontalVisibleItems),function(item,index){return _c('div',{key:index,staticClass:"price-breakdown-item-horizontal",style:({
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '0',
              flex: '1',
              maxWidth: 'calc(33% - 3px)',
              marginBottom: '4px',
              padding: '4px 2px',
            })},[_c('div',{staticClass:"price-label-horizontal",style:({
                color: '#a3a4ab',
                fontWeight: '500',
                fontSize: '10px',
                textAlign: 'center',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                width: '100%',
                marginBottom: '2px',
              })},[_vm._v(" "+_vm._s(item.DisplayName || _vm.priceTypes[item.PriceType])+" ")]),_c('div',{staticClass:"price-value-horizontal",style:({
                padding: '4px 6px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#e7f2fd',
                borderRadius: '8px',
                fontSize: '10px',
                fontWeight: '500',
                color: '#2396f3',
                minHeight: '22px',
                whiteSpace: 'nowrap',
                width: '100%',
              })},[_vm._v(" "+_vm._s(item.Value.toFixed(2))+" "+_vm._s(_vm.currency)+" ")])])}),(_vm.hasHorizontalHiddenItems)?_c('div',{style:({
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              paddingBottom: '4px',
              width: '100%',
              position: 'relative',
            }),on:{"click":_vm.toggleShowAll}},[_c('div',{style:({
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                color: '#2396f3',
                fontSize: '11px',
                fontWeight: '500',
              })},[_c('span',[_vm._v(_vm._s(_vm.showAll ? 'Daha Az' : `+${_vm.horizontalHiddenItemsCount} Daha`))]),_c('v-icon',{style:({ 
                  fontSize: '14px',
                  transform: _vm.showAll ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.2s ease'
                })},[_vm._v(" mdi-chevron-down ")])],1)]):_vm._e()],(_vm.showAll && (_vm.hasHiddenItems || _vm.hasHorizontalHiddenItems))?_c('div',{staticClass:"price-tooltip",style:({
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: 'white',
            border: '1px solid #ddd',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            zIndex: 9999,
            padding: '12px',
            marginTop: '4px',
            minWidth: '200px',
            width: '100%',
          })},[_c('div',{style:({
              display: 'flex',
              flexDirection: 'column',
              gap: '6px',
            })},_vm._l((_vm.tooltipItems),function(item,index){return _c('div',{key:'hidden-' + index,style:({
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                minWidth: 0,
                maxWidth: '100%',
              })},[_c('div',{style:({
                  color: '#a3a4ab',
                  fontWeight: '500',
                  fontSize: '12px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  flex: '1',
                  marginRight: '8px',
                })},[_vm._v(" "+_vm._s(item.DisplayName || _vm.priceTypes[item.PriceType])+" ")]),_c('div',{style:({
                  padding: '3px 8px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: '#e7f2fd',
                  borderRadius: '12px',
                  fontSize: '12px',
                  fontWeight: '500',
                  color: '#2396f3',
                  minHeight: '22px',
                  whiteSpace: 'nowrap',
                  flexShrink: 0,
                })},[_vm._v(" "+_vm._s(item.Value.toFixed(2))+" "+_vm._s(_vm.currency)+" ")])])}),0)]):_vm._e()],2):_vm._e()])]),_c('div',{staticStyle:{"height":"50%"}},[_c('div',{style:({
      opacity: _vm.isExceedsLimits ? 0.5 : 1,
      height: '50%'
    })},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center","margin-bottom":"4px","height":"60%"},style:({
          paddingLeft: _vm.$vuetify.breakpoint.lg ? '4px' : '16px',
          paddingRight: _vm.$vuetify.breakpoint.lg ? '4px' : '16px',
        })},[_c('div',{staticClass:"d-flex align-items-center",staticStyle:{"width":"45%","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}},[_c('v-icon',{staticStyle:{"font-size":"18px","margin-right":"8px"},attrs:{"color":"black"}},[_vm._v(" mdi-arrow-top-right-thin-circle-outline ")]),_c('div',{staticStyle:{"font-size":"24px","font-weight":"500","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}},[_vm._v(" "+_vm._s(_vm.origin)+" ")])],1),_c('div',{staticClass:"d-flex justify-center items-center",staticStyle:{"width":"10%"}},[_c('img',{staticStyle:{"height":"auto"},style:({ width: _vm.$vuetify.breakpoint.lg ? '28px' : '32px' }),attrs:{"src":_vm.iconPath,"alt":"Transport Icon"}})]),_c('div',{staticClass:"d-flex align-items-center justify-end",staticStyle:{"width":"45%","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}},[_c('v-icon',{staticStyle:{"font-size":"18px","margin-right":"8px"},attrs:{"color":"black"}},[_vm._v(" mdi-arrow-bottom-right-thin-circle-outline ")]),_c('div',{staticStyle:{"font-size":"24px","font-weight":"500","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}},[_vm._v(" "+_vm._s(_vm.destination)+" ")])],1)]),(_vm.duration !== 0 && _vm.duration !== null)?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center","position":"relative","border-bottom":"1px solid #ddd","height":"40%"},style:({
          paddingLeft: _vm.$vuetify.breakpoint.lg ? '6px' : '20px',
          paddingRight: _vm.$vuetify.breakpoint.lg ? '6px' : '20px',
        })},[_c('div',{staticStyle:{"width":"10px","height":"10px","border-radius":"50%","background-color":"#4cd074"}}),_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","gap":"4px"}},_vm._l((_vm.greenLineWidths),function(width,index){return _c('div',{key:'green-' + index,staticStyle:{"height":"2px","background-color":"#dfdfdf","border-radius":"10px"},style:({ width: width + 'px' })})}),0),_c('div',{staticStyle:{"font-size":"15px","font-weight":"500","color":"#8f949a"}},[_vm._v(" "+_vm._s(_vm.duration)+" "+_vm._s(_vm.$t("labels.day.both"))+" ")]),_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","gap":"4px"}},_vm._l((_vm.grayLineWidths),function(width,index){return _c('div',{key:'gray-' + index,staticStyle:{"height":"2px","background-color":"#dfdfdf","border-radius":"10px"},style:({ width: width + 'px' })})}),0),_vm._m(0)]):_vm._e()]),_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between","border-bottom":"1px solid #ddd","padding-left":"16px","padding-right":"16px","cursor":"pointer","height":"30%"},style:({ opacity: _vm.isExceedsLimits ? 0.5 : 1 }),on:{"click":_vm.openPackageDetails}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center"}},[_c('svg',{attrs:{"width":"24px","height":"24px","stroke-width":"1.5","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg","color":"#676a6d"}},[_c('path',{attrs:{"d":"M2.6954 7.18536L11.6954 11.1854L12.3046 9.81464L3.3046 5.81464L2.6954 7.18536ZM12.75 21.5V10.5H11.25V21.5H12.75ZM12.3046 11.1854L21.3046 7.18536L20.6954 5.81464L11.6954 9.81464L12.3046 11.1854Z","fill":"#676a6d"}}),_c('path',{attrs:{"d":"M3 17.1101V6.88992C3 6.65281 3.13964 6.43794 3.35632 6.34164L11.7563 2.6083C11.9115 2.53935 12.0885 2.53935 12.2437 2.6083L20.6437 6.34164C20.8604 6.43794 21 6.65281 21 6.88992V17.1101C21 17.3472 20.8604 17.5621 20.6437 17.6584L12.2437 21.3917C12.0885 21.4606 11.9115 21.4606 11.7563 21.3917L3.35632 17.6584C3.13964 17.5621 3 17.3472 3 17.1101Z","stroke":"#676a6d","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.5 4.5L16.1437 8.34164C16.3604 8.43794 16.5 8.65281 16.5 8.88992V12.5","stroke":"#676a6d","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('div',{staticStyle:{"margin-left":"8px","font-size":"15px","font-weight":"500"}},[_vm._v(" "+_vm._s(_vm.packageDetails)+" ")])]),_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center"}},[_c('svg',{attrs:{"width":"24px","height":"24px","stroke-width":"1.5","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg","color":"#676a6d"}},[_c('path',{attrs:{"d":"M9 6L15 12L9 18","stroke":"#676a6d","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])])]),_c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center","height":"25%"}},[(_vm.isExceedsLimits && _vm.exceededLimitMessage)?_c('div',{staticStyle:{"background":"#ffebee","width":"100%","height":"100%","color":"#c62828","border-bottom-right-radius":"15px","border-bottom-left-radius":"15px","font-weight":"bold","text-align":"center","display":"flex","align-items":"center","justify-content":"center","padding":"8px","font-size":"14px"}},[_vm._v(" "+_vm._s(_vm.exceededLimitMessage)+" ")]):_c('button',{style:({
          background: '#283058',
          width: '100%',
          height: '100%',
          color: 'white',
          borderBottomRightRadius: '15px',
          borderBottomLeftRadius: '15px',
          fontWeight: 'bold',
          textAlign: 'center',
          border: 'none',
          cursor: 'pointer',
          opacity: _vm.isExceedsLimits ? 0.5 : 1
        }),attrs:{"disabled":_vm.isExceedsLimits},on:{"click":_vm.createOrder}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","gap":"6px"}},[_c('svg',{attrs:{"width":"24px","height":"24px","stroke-width":"1.5","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg","color":"#ffffff"}},[_c('path',{attrs:{"d":"M7 12.5L10 15.5L17 8.5","stroke":"#ffffff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z","stroke":"#ffffff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})]),_vm._v(" "+_vm._s(_vm.$t("buttons.createOrder"))+" ")])])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","width":"10px","height":"10px","border-radius":"50%","background-color":"#c5c5c5"}},[_c('div',{staticStyle:{"width":"6px","height":"6px","border-radius":"50%","background-color":"#fff"}})])
}]

export { render, staticRenderFns }